import React from 'react';

const CollapsableContentLink = ({ children }) => (
  <ul className="collapsableContent-body-list">{children}</ul>
);

export default CollapsableContentLink;
